import { style } from '@vanilla-extract/css'

import { getFontSize } from '~/styles/mixins/font.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const profileCard = style({
  height: '100%',
})

export const profileCard_container = style({
  height: '100%',
})

export const profileCardIcon = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const profileCardIcon_icon = style({})

export const profileCardTitle = style({
  marginTop: 12,
})

export const profileCardTitle_text = style({
  fontSize: getFontSize(16),
  fontWeight: cssVariables.font.weight.bold,
  textAlign: 'center',
})

export const profileCardDescription = style({})

export const profileCardDescription_paragraph = style({
  fontSize: getFontSize(12),
  textAlign: 'center',
})
